import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrashPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrashPaper"><Path d="M14.0556 1.84863L10.6942 4.08952L3.45703 5.20294L3.99553 9.51095L2 10.5087V14.457L3.59003 15.517L4.10663 19.6498L7.36576 21.6052L10.7873 19.65L12.7688 22.1269L16.4914 20.886L21.1777 16.7855L19.0623 13.0836L22.3892 8.64776L17.8889 6.39761V4.40419L14.0556 1.84863Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrashPaper;
